/* eslint-disable @angular-eslint/use-lifecycle-interface */

import { Component, OnInit, inject, OnDestroy, ViewEncapsulation, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlContainer, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
// import { GRANTTYPE } from "src/app/core/constants";
import { PreAuthorisationModel } from 'src/app/core/models/pre-authorisation.model';

import { MdbDatepickerModule, MdbSelectModule, MdbModalService } from 'src/lib/mdb5-adapted/public-api';
import { LMSDialogHandlerService } from 'src/app/shared/lmsdialog-handler.service';
import { LMSConstantsService } from '@lmsConstants';
import { ZARcurrencyPipe } from '@lmsSharedUI';
import { UniquePayslip } from 'src/app/shared/directives';
import { PaySlipModel, PaySlipModel1 } from '@lmsModels';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sassa-editor',
  templateUrl: './sassa-editor.component.html',
  styleUrls: ['./sassa-editor.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MdbDatepickerModule, MdbSelectModule, ZARcurrencyPipe],
  encapsulation: ViewEncapsulation.Emulated,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true })
    }
  ]
})
export class SassaEditorComponent implements OnInit, OnDestroy {
  @Input() controlKey = '';
  parentContainer = inject(ControlContainer);
  private readonly lmsConstantsService = inject(LMSConstantsService);
  @Input() sallabel?: string;
  @Input() Submitted: boolean = false;
  @Input() preauthModel!: PreAuthorisationModel;
  @Output() paySlipCaptured = new EventEmitter<PaySlipModel1>();
  // lstGrantType = GRANTTYPE;
  lstGrantTypes = this.lmsConstantsService.getLMSConstant('GRANTTYPE') || [];
  lstGrantCategories = this.lmsConstantsService.getLMSConstant('GRANTCATEGORY') || [];

  originalEmployer: string;

  maxDate = new Date();
  payDateError = '';
  startDate = new Date(2010, 0, 1);
  invalidDate = false;

  invalidEndDate = false;

  payslipResult: string;
  // month1 = 0;
  // month2 = 0;
  // month3 = 0;

  income1 = 0;
  income2 = 0;
  income3 = 0;

  private readonly disabilityGrantTypeValues = new Set(['disability', 'disabled']);
  private grantTypeSub?: Subscription;
  private grantCategorySub?: Subscription;

  private readonly fallbackControl = new FormControl(null);
  private readonly fallbackGroup = new FormGroup({});

  get showContractOrTemporary() {
    const ctype = this.f.grantCategory?.value;
    return (ctype && ctype !== 'Temporary');
  }

  get parentFormGroup() {
    return this.parentContainer.control as FormGroup;
  }

  get f() {
    return (this.parentFormGroup.get(this.controlKey) as FormGroup).controls;
  }

  get totalIncome() {
    return +this.income1 + +this.income2 + +this.income3;
  }

  get grantCategory() {
    return this.f.grantCategory;
  }

  get grantType() {
    return this.f.grantType;
  }

   get employmentStartDate () {
    return this.f?.employmentStartDate || this.fallbackControl;
  }

  get contractStartDate () {
    return this.f?.contractStartDate || this.fallbackControl;
  }

  get contractEndDate () {
    return this.f?.contractEndDate || this.fallbackControl;
  }

  get payslips () {
    return (this.f?.payslips as FormGroup) || this.fallbackGroup;
  }

  get payslipControls() {
    const control = this.payslips?.controls;
    return control;
  }

  constructor( private modalService: MdbModalService,
    public lmsDialogHandler: LMSDialogHandlerService,
  ){}

  ngOnInit() {
    this.parentFormGroup.addControl(this.controlKey
      , new FormGroup({
        grantCategory: new FormControl({value:'', disabled: true}),
        grantType: new FormControl(this.lstGrantTypes[0]?.value || '', [Validators.required]),
        employmentStartDate:new FormControl(null),
        contractStartDate: new FormControl(null),
        contractEndDate: new FormControl(null),
        payslips: new FormGroup(
          {
            payslip1: new FormControl({}),
            payslip2: new FormControl({}),
            payslip3: new FormControl({}),
          },{ validators: UniquePayslip })
      }, { updateOn: 'change' }),
      { emitEvent: false });

    this.applyGrantValidators();

    this.grantTypeSub = this.grantType?.valueChanges.subscribe(() => {
      this.toggleGrantType();
    });

    this.grantCategorySub = this.grantCategory?.valueChanges.subscribe(() => {
      this.toggleGrantDates();
      this.applyGrantValidators();
    });

    this.toggleGrantType();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.preauthModel && changes.preauthModel.currentValue) {
      if (!this.Submitted && Object.keys(changes.preauthModel.currentValue).length > 0) {
        setTimeout(() => {
          this.preauthModel = changes.preauthModel.currentValue;
          this.updateProfile(changes.preauthModel.currentValue);
        });
      }
    }
  }

  updateProfile(preAuth: PreAuthorisationModel) {
    if (!preAuth || Object.values(preAuth).length == 0) {
      return;
    }

    const toDateOrDefault = (value: any, fallback: Date | null) => {
      if (!value) {
        return fallback;
      }
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? fallback : date;
    };

    const employerDetailsModel = (preAuth.employment && preAuth.employment.id > 0) ? preAuth.employment : preAuth;
    //Set Defaults if employment changed from SASSA
    if (employerDetailsModel.employmentType !== 'SASSA') {
      employerDetailsModel.employmentType = 'Temporary';
      employerDetailsModel.employerTNR = 0;
      employerDetailsModel.wageFrequency = 'Monthly';
      employerDetailsModel.workSaturday = false;
      employerDetailsModel.industryType = '';
      employerDetailsModel.occupation = 'Disability';
      employerDetailsModel.employmentStartDate = null;
    }

    // Keep the original employment
    this.originalEmployer = preAuth.employer || preAuth.employment.name || preAuth.employerName || '';
    const defaultOccupation = employerDetailsModel.occupation || (employerDetailsModel.employmentType === 'Temporary' ? 'Disability':'Old age pension');
    this.f.grantType.setValue(defaultOccupation || 'Disability', { onlySelf: true, emitEvent: false });



    if (preAuth.payslips && preAuth.payslips.length > 0) {
      preAuth.payslip1 ||= preAuth.payslips[0] ?? null;
      if (preAuth.payslip1 && preAuth.payslip1.payslipDate) {
        preAuth.payslip1.date = preAuth.payslip1.payslipDate;
        preAuth.payslip1.month = 1;
        this.income1 = +preAuth.payslip1.nettIncome + +preAuth.payslip1.otherIncome;
      }
      preAuth.payslip2 ||= preAuth.payslips[1] ?? null;
      if (preAuth.payslip2 && preAuth.payslip2.payslipDate) {
        preAuth.payslip2.date = preAuth.payslip2.payslipDate;
        preAuth.payslip2.month = 2;
        this.income2 = +preAuth.payslip2.nettIncome + +preAuth.payslip2.otherIncome;
      }
      preAuth.payslip3 ||= preAuth.payslips[2] ?? null;
      if (preAuth.payslip3 && preAuth.payslip3.payslipDate) {
        preAuth.payslip3.date = preAuth.payslip3.payslipDate;
        preAuth.payslip3.month = 3;
        this.income3 = +preAuth.payslip3.nettIncome + +preAuth.payslip3.otherIncome;
      }
    }
    this.toggleGrantType();

    // Aliased as
    // Temporary == Disability
    // Permanent == Old age pension

    if (this.f.grantCategory.value !== 'Temporary') {
      this.f.employmentStartDate.setValue(toDateOrDefault(employerDetailsModel.employmentStartDate, null), {
        onlySelf: false,
      });
    }
    else {
      this.f.contractStartDate.setValue(toDateOrDefault(employerDetailsModel.contractStartDate, null), {
        onlySelf: false,
      });
      this.f.contractEndDate.setValue(toDateOrDefault(employerDetailsModel.contractEndDate, null), {
        onlySelf: false,
      });
    }
  }

  toggleGrantType() {
    const grantType = this.grantType?.value;
    const showGrantCategory = this.isGrantCategoryVisible();
    const currentCategory = `${this.grantCategory?.value ?? ''}`;

    if (showGrantCategory) {
      this.grantCategory?.enable();
      if (currentCategory !== 'Temporary' && currentCategory !== 'Permanent') {
        this.f.grantCategory.setValue('Temporary' , { onlySelf: false, emitEvent: true });
      }
      //this.f.grantCategory.setValue(grantType == 'Disability' ? 'Temporary': 'Permanent' , { onlySelf: true, emitEvent: true });
    } else {
      this.grantCategory?.disable();
      this.f.grantCategory.setValue('Permanent' , { onlySelf: false, emitEvent: true });
    }

    console.info('Grant Type >> ',grantType)

    // Aliased as
    // Temporary == Disability
    // Permanent == Old age pension
    this.toggleGrantDates();
    this.applyGrantValidators();
    //this.parentFormGroup.updateValueAndValidity();
  }

  isGrantCategoryVisible(): boolean {
    const grantType = `${this.grantType?.value ?? ''}`.trim().toLowerCase();
    return this.disabilityGrantTypeValues.has(grantType);
  }

  private resolveDateInput(input: any): Date | null {
    const raw = input?.target?.value ?? input?.value ?? input;
    if (!raw) {
      return null;
    }

    const date = raw instanceof Date ? raw : new Date(raw);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  toggleGrantDates(){
    if (this.grantCategory?.value == 'Permanent') {
      this.employmentStartDate?.enable();
      this.contractStartDate?.disable();
      this.contractEndDate?.disable();
    } else {
      this.employmentStartDate?.disable();
      this.contractStartDate?.enable();
      this.contractEndDate?.enable();
    }

    const minemploymentStartDate = new Date();
    minemploymentStartDate.setMonth(minemploymentStartDate.getMonth() - 3);
    minemploymentStartDate.setDate(minemploymentStartDate.getDay() - 1);
    this.maxDate = minemploymentStartDate;

    this.employmentStartDate
    this.applyGrantValidators();
  }

  private applyGrantValidators(): void {
    const showGrantCategory = this.isGrantCategoryVisible();
    const isTemporaryGrant = showGrantCategory && this.grantCategory?.value === 'Temporary';

    this.grantCategory?.setValidators(showGrantCategory ? [Validators.required] : []);
    this.employmentStartDate?.setValidators(!isTemporaryGrant ? [Validators.required] : []);
    this.contractStartDate?.setValidators(isTemporaryGrant ? [Validators.required] : []);
    this.contractEndDate?.setValidators(isTemporaryGrant ? [Validators.required] : []);

    this.grantCategory?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    this.employmentStartDate?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    this.contractStartDate?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    this.contractEndDate?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
  }

  ngOnDestroy() {
    this.grantTypeSub?.unsubscribe();
    this.grantCategorySub?.unsubscribe();
    this.parentFormGroup.removeControl(this.controlKey);
  }

  GrantDateSelected(event: any) {
    const selectedDate = this.resolveDateInput(event) || this.resolveDateInput(this.contractStartDate?.value) || this.resolveDateInput(this.employmentStartDate?.value);
    if (!selectedDate) {
      this.invalidDate = false;
      this.payDateError = '';
      return;
    }



    const payMonth = 3;
    const payYear = 0;
    this.payDateError = "";
    this.startDate = selectedDate;
    const _employmentStartDate = new Date();
    _employmentStartDate.setFullYear(_employmentStartDate.getFullYear() - payYear);
    _employmentStartDate.setMonth(_employmentStartDate.getMonth() - payMonth);

    this.invalidDate = (selectedDate > _employmentStartDate);
    if (this.invalidDate) {
      this.payDateError = "WARNING! start date is less than 3 months";
    }
  }

  GrantEndDateSelected(event: any) {
    const selectedDate = this.resolveDateInput(event);
    const _employmentStartDate = this.resolveDateInput(this.f.contractStartDate.value || this.f.employmentStartDate.value);

    if (!selectedDate || !_employmentStartDate) {
      this.invalidEndDate = false;
      this.invalidDate = false;
      this.payDateError = '';
      return;
    }


    this.invalidEndDate = selectedDate <= _employmentStartDate;
    this.invalidDate = this.invalidEndDate;
    if (this.invalidEndDate) {
      this.payDateError = "End Date must be after Start Date";
    }

    if (this.grantCategory?.value === 'Temporary') {
      this.f.contractEndDate.setValue(selectedDate ?? null, { emitEvent: false });
    }
  }


  openPaySlip(mnth: string | number) {
    console.log("Saving payslip: " + mnth);
    let pslipModel = {} as PaySlipModel1;
    if (Number(mnth) === 1) {
      pslipModel = this.preauthModel.payslip1;
    } else if (Number(mnth) === 2) {
      pslipModel = this.preauthModel.payslip2;
    } else if (Number(mnth) === 3) {
      pslipModel = this.preauthModel.payslip3;
    }

    this.lmsDialogHandler.openPayslipDialog(mnth, pslipModel, this.sallabel)
      ?.onClose.subscribe((pslip: PaySlipModel1) => {
        if (pslip) {
          pslip.otherIncome ||= 0;

          const totIn = +pslip.nettIncome + +pslip.otherIncome;
          this.payslipResult = JSON.stringify(pslip);
          console.log(this.payslipResult, "payslipR");

          if (mnth == '1') {
            this.preauthModel.payslip1 = pslip;
            this.payslipControls['payslip1']?.patchValue(pslip,{ onlySelf: true, emitEvent: true });
            this.income1 = totIn;
          } else if (mnth == '2') {
            this.preauthModel.payslip2 = pslip;
            this.payslipControls['payslip2']?.patchValue(pslip,{ onlySelf: true, emitEvent: true });
            this.income2 = totIn;
          } else if (mnth == '3') {
            this.preauthModel.payslip3 = pslip;
            this.payslipControls['payslip3']?.patchValue(pslip,{ onlySelf: true, emitEvent: true });
            this.income3 = totIn;
          }
          this.payslips.updateValueAndValidity();

          if (this.paySlipCaptured) {
            this.paySlipCaptured.emit(pslip);
          }
        }
      });
  }

}
